import styled from 'styled-components';

export const AgentOuterShell = styled.div`
    display: flex;
    padding: 16px;
    background: #fff;
    border: 1px solid #d8d8d8;
    border-radius: 0.75rem;
    flex-direction: column;
    justify-content: space-between;
`

export const CardAnchor = styled.a`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    /* height: 100%; */
`

export const RowInfo = styled.div`
display: flex;
    flex-basis: 30%;
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin-bottom: 12px;
`

export const StatFlex = styled(RowInfo)`
    grid-column-gap: 10px;
`

export const NameInfo = styled.div`
    margin-left: 16px;

`

export const NameRow = styled.div`
    display: inline-flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    // line-height: 32px;
    color: #111;
`   

export const LocationRow = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.7);
`

export const AboutRow = styled.p`
    color: rgba(0, 0, 0, 0.5);
    font-size: 13px;        
    overflow: hidden;
  text-overflow: ellipsis;
  max-height: 50px;
  line-height: 18px;
  height: 100%;
  /* word-break: break-all; */
  /* white-space: nowrap; */
  width: 100%;
  margin-bottom: 16px;
`

export const StatCircle = styled.div`
    background: rgba(0, 0, 0, 0.4);
    padding: 0px 8px;
    color: white;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 4px;
    /* color: #111; */
    /* background-color: #d8d8d8; */
    border-radius: 50%;
    font-weight: 600;
    line-height: 20px;
`

export const StatHolder = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 8px;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: #111;
`

export const ResponseTime = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    column-gap: 6px;
    font-size: 12px;
    color: #98A2B2;
    margin-bottom: 6px;
    font-family: 'Inter', sans-serif;
`